import request from '@/api/request'

/**
 * 获取当前客户的全部未读警报
 * @returns {AxiosPromise}
 */
export function listUnReadDeviceAlarm () {
  return request({
    url: 'webapi/gps/alarm/listUnReadDeviceAlarm',
    method: 'get'
  })
}

export function setAlarmRead (data) {
  const req = {
    alarmId: data
  }
  return request({
    url: 'webapi/gps/alarm/setAlarmRead',
    method: 'post',
    data: req
  })
}

export function listAlarm (data) {
  let req = {
    deviceImei: data.deviceImei,
    startTime: data.startTime,
    endTime: data.endTime,
    pageNum: data.pageNum,
    pageSize: data.pageSize,
  }
  return request({
    url: 'webapi/gps/alarm/listDeviceAlarm',
    method: 'post',
    data: req
  })
}
